abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.plans = abcsetup.promos.plans || {};
abcsetup.promos.plans.review = abcsetup.promos.plans.review || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.plans.review = {
    init: function() {
        this.initListeners();
    },
    initListeners: () => {
        // Approval all button clicked
        $(document).on('click', '#btn-approve-all', function (e) {
            $('input:radio[value="cm_accepted"]').prop('checked',true).closest('tr').removeClass('cm_declined').addClass('cm_accepted');
            $('tr.reject_reason').hide().find('textarea.reject_reason').prop('required',false);
        });

        // Approval all button clicked
        $(document).on('click', '#btn-reject-all', function (e) {
            $('input:radio[value="cm_declined"]').prop('checked',true).closest('tr').removeClass('cm_accepted').addClass('cm_declined');
            $('tr.reject_reason').show();
            $('tr.reject_reason').find('textarea.reject_reason').prop('required',true);
        });

        // Approval all button clicked
        $(document).on('click', '#btn-unmark-all', function (e) {
            $('input.btn-options').prop('checked', false);
            $('input:radio').closest('tr').removeClass('cm_accepted cm_declined');
            $('tr.reject_reason').hide().find('textarea.reject_reason').prop('required',false);
        });

        $(document).on('click', '.btn-options', function(e) {
            if($(this).val() === 'cm_declined') {
                $(this).closest('tr').removeClass('cm_accepted').addClass('cm_declined');
            }
            else if($(this).val() === 'cm_accepted') {
                $(this).closest('tr').removeClass('cm_declined').addClass('cm_accepted');
            }
        });

        $('input:radio').on('change', function (e) {
            if ($(this).val() === 'cm_declined') {
                $(this).closest('tr').next('tr.reject_reason').show().find('textarea.reject_reason').prop('required',true);
            } else if($(this).val() === 'cm_accepted') {
                $(this).closest('tr').next('tr.reject_reason').hide().find('textarea.reject_reason').prop('required',false);
            }
        });

        if(!$(':radio').length) {
            $('#btn-approve-all').attr('disabled', true).addClass('disabled');
            $('#btn-reject-all').attr('disabled', true).addClass('disabled');
            $('#btn-unmark-all').attr('disabled', true).addClass('disabled');
            $('#btn-submit').attr('disabled', true).addClass('disabled');
        }
    }
}
